import { render, staticRenderFns } from "./PTSHeader.vue?vue&type=template&id=23a2ed82&lang=pug"
import script from "./PTSHeader.vue?vue&type=script&lang=js"
export * from "./PTSHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports